import React from 'react';
import { FormattedMessage } from 'react-intl';

// constants
import { RECIPIENT_FILTER_FIELD_NAMES } from '../../../../../../constraints';

// Components
import { ControlledTextField } from '../../../../../../components/ControlledTextField';
import { FieldLabel } from '../../../../../../components/Form';

const TextNameField = ({ name = RECIPIENT_FILTER_FIELD_NAMES.NAME }) => {
  return (
    <>
      <FieldLabel>
        <FormattedMessage
          id="Name and surname"
          defaultMessage="Name and surname"
        />
      </FieldLabel>
      <ControlledTextField name={name} />
    </>
  );
};

export default TextNameField;
